module.exports = __webpack_public_path__ + "static/media/about_banner.8d70257c.jpg";